import type { NextPageWithLayout } from "@interfaces/PageInterfaces";
import { womenCategoryPage } from "@lib/constants/pagePaths";
import { PageTypes } from "@lib/enums/PageTypes";
import { getDefaultLayout, getProductListLayout } from "@lib/utils/layoutUtility";
import type { GetServerSidePropsContext, PreviewData } from "next";
import type { ParsedUrlQuery } from "querystring";
import {
    ProductCategoryPage,
    type ProductCategoryPageProps,
    generateGetServerSidePropsForCategoryPage,
} from "templates/ProductCategoryPage";
import { ProductListingPage, type ProductListingPageProps } from "templates/ProductListingPage";

const WomenCategoryPage: NextPageWithLayout<ProductCategoryPageProps> = (props) => {
    return (
        <>
            <div hidden aria-hidden="true" data-testid="womenIndex" />
            {props.pageType === PageTypes.PLP ? (
                <ProductListingPage isMenPage={false} {...(props as ProductListingPageProps)} />
            ) : (
                <ProductCategoryPage {...props} />
            )}
        </>
    );
};

export default WomenCategoryPage;

WomenCategoryPage.getLayout = (props) => {
    const { page } = props;
    const { pageType } = page.props;
    return pageType === PageTypes.PLP ? getProductListLayout(props) : getDefaultLayout(props);
};

export const getServerSideProps = async (
    context: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>
) => {
    return await generateGetServerSidePropsForCategoryPage(context, womenCategoryPage);
};
